
























































import { Portal } from "@infoland/iprova-api";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import storeHelper from "../../store/store-helper";
import _ from "lodash";
import { settingName } from "@infoland/iprova-api";

export default Vue.extend({
    name: "PathMenu",
    components: {},
    props: {
        showPortalName: Boolean,
        showPageLocation: Boolean,
        disablePortalClick: Boolean,
        pageLocation: String,
        portalId: Number,
        showDocumentTitle: Boolean,
        documentTitle: String
    },
    data: () => ({
        productName: "" as string
    }),
    computed: {
        shouldDisplayPortal(): boolean {
            return (this.showPortalName && this.$vuetify.breakpoint.smAndUp) || (!this.showPageLocation && this.pageLocation == null);
        },
        shouldDisplayProduct(): boolean {
            return this.productName && this.productName.toLowerCase() == "zenya"
                ? false
                : this.$vuetify.breakpoint.smAndUp || (!this.showPortalName && !this.showPageLocation);
        },
        portal(): Portal {
            if (this.portalId) return storeHelper.portalStore.getPortal(this.portalId);
            return null;
        },
        portalName(): string {
            return this.portal?.name;
        },
        routeName(): TranslateResult {
            const translationKey = `general.route.${_.camelCase(this.$route.name)}`;
            return this.$t(translationKey);
        },
        smAndDown(): boolean {
            return this.$vuetify.breakpoint.smAndDown;
        }
    },
    methods: {
        portalClick() {
            if (!this.disablePortalClick) {
                this.$router.push({ name: "Portal", params: { portalId: this.portalId.toString() } });
            }
        }
    },
    async created() {
        this.productName = await storeHelper.settingsStore.getSettingAsync<string>(settingName.product_name);
    }
});
